// extracted by mini-css-extract-plugin
export default {"hardness":"bjB4T","popoverInfo":"L1C3X","popover":"aZtl9","name":"h0TA0","icon":"BZX42","value":"YZeZO","text":"VKYq3"};